import React, { FC } from "react";
import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import { useAppTheme } from "@/utils/theme";

export type Filters = {
  sortField: string;
  sortOrder: number;
  pageNumber: number;
  pageSize: number;
  search: string;
};

export const defaultFilters: Filters = {
  sortField: "name",
  sortOrder: 1,
  pageNumber: 0,
  pageSize: 10,
  search: "",
};

type Props = {
  filtersState: [Filters, React.Dispatch<React.SetStateAction<Filters>>];
  placeHolder: string;
};

export const DataTableFilters: FC<Props> = ({ filtersState, placeHolder }) => {
  const theme = useAppTheme();
  const [filters, setFilters] = filtersState;

  return (
    <Box
      sx={{
        display: "flex",
        gap: "0.5rem",
        width: "100%",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "row",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.surface.light2,
          px: 2,
          width: {
            xs: "100%",
            sm: "100%",
          },
        }}
        className="flex rounded-lg py-3 max-w-full items-center justify-between h-14"
      >
        <InputBase
          className="flex-1"
          placeholder={placeHolder}
          inputProps={{ "aria-label": "search" }}
          onChange={(e) => {
            setFilters((filters) => ({
              ...filters,
              search: e.target.value,
              pageNumber: 0,
            }));
          }}
          value={filters.search}
        />
        <SearchIcon className="text-icon-primary" />
      </Box>
    </Box>
  );
};

export default DataTableFilters;
